import { createSelector } from 'reselect'

const getStudentViewData = state => state.student
const getSlideId = (state, slide_uid) => slide_uid

const studentOeqSubmitSelector = createSelector(
	[ getStudentViewData, getSlideId ],
	(student, slideId) => {
		const slide_data = student.slides[slideId]

		const answers = {
			[slide_data.answers[0].key]: slide_data.answers[0].text,
		}

		return {
			answers,
			device_uid: student.device_uid,
			headers: student.headers,
			editsCount: slide_data.editsCount,
			audioUid: slide_data.audioServerUid,
			audioClientUid: slide_data.audioClientUid,
		}
	}
)

export default studentOeqSubmitSelector
